import { Directive, ElementRef, HostBinding, HostListener, Input } from '@angular/core';
import { AccountDisplayTypes } from '../module-config/module-config';

@Directive({
  selector: '[appResponsiveAccount]'
})
export class ResponsiveAccountDirective {

  constructor(){}

  @HostBinding('style.margin') elementMargin!:any;
  @HostBinding('style.max-width.px') elementWidth:any;
  @Input() displayAreaConfig!:AccountDisplayTypes;

  ngOnInit(): void{
    this.configureAccountUi();
  }

  private configureAccountUi(): void {
    if(this.displayAreaConfig == "main-menu"){
      this.elementWidth = 550;
      this.elementMargin = "100px auto 100px auto"
    }else if(this.displayAreaConfig == "side-menu"){
      this.elementMargin = "auto"
    }else{
      throw new Error("unknown module configuration!");
    }
  }

}